/**
 * Client for sending requests to the search api
 */
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'
import searcherry from '@/services/Searcherry/Searcherry'

class SearchApiClient {
  private xhr = new XMLHttpRequest()

  makeRequest (url: URL) {
    return new Promise((resolve, reject) => {
      // const xhr = new XMLHttpRequest()
      this.xhr.abort()
      // @ts-ignore на самом деле можно передавать не строку, а URL
      this.xhr.open('GET', url)
      this.xhr.onload = () => {
        resolve(JSON.parse(this.xhr.responseText))
        this.afterRequest()
      }
      this.xhr.onerror = () => {
        reject(JSON.parse(this.xhr.statusText))
        this.afterRequest()
      }
      this.xhr.onabort = () => {
        this.afterRequest()
      }
      this.beforeRequest()
      this.xhr.send()
    })
  }

  abortRequest () {
    this.xhr.abort()
  }

  search (searchText: string) {
    let url = new URL(searcherryConfig.apiUrl + '/search/all')
    url.searchParams.set('query', this.filterSearchText(searchText))
    return this.makeRequest(url)
  }

  searchCategory (searchText: string, categorySiteId: number, page: number, pageSize: number) {
    let url = new URL(searcherryConfig.apiUrl + '/search/category')
    url.searchParams.set('query', this.filterSearchText(searchText))
    url.searchParams.set('categoryId', categorySiteId.toString())
    url.searchParams.set('pageSize', pageSize.toString())
    url.searchParams.set('page', page.toString())

    return this.makeRequest(url)
  }

  private filterSearchText (searchText: string) {
    searchText = searchText
      .trim()
      // .replace(/\/+/, ' ')
      .replace(/\s+/, ' ')

    let searchTextAr = searchText.split(' ')
    searchTextAr = searchTextAr.filter((value, index, self) => {
      return value !== '' && self.indexOf(value) === index
    })
    searchText = searchTextAr.join(' ')
    searchText = encodeURI(searchText)

    return searchText
  }

  private beforeRequest () {
    searcherry.generateEvent('before-api-request')
    document.documentElement.classList.add('_srchrry-loading')
  }

  private afterRequest () {
    searcherry.generateEvent('after-api-request')
    document.documentElement.classList.remove('_srchrry-loading')
  }
}

const searchApiClient = new SearchApiClient()

export default searchApiClient
